export default __webpack_public_path__ + "static/media/contact.a00e19b8.png";